export const omit = (obj, ...keys) => {
    const res = { ...obj };
    for (const key of keys) {
        if (key in res)
            delete res[key];
    }
    return res;
};
//# sourceMappingURL=omit.js.map